import { ColumnConfig } from "@app/shared/waffles";
import { Waffles } from "@app/shared/waffles/Waffles";
import { FC } from "react";
import { ProviderProfileFlyoutTableData } from "@app/projects/network-assessment/provider-hub/provider-profile/interfaces/providerProfileFlyoutTableInterfaces";
import { AccessGapTypeEnum } from "@app/projects/network-assessment/provider-hub/enumerators";

interface ProviderProfileFlyoutTableProps {
  data: ProviderProfileFlyoutTableData[];
  gapType: AccessGapTypeEnum.PartiallyFillableGap | AccessGapTypeEnum.FillableBySingleProvider;
}

const columnConfig: ColumnConfig = {
  address: {
    displayText: "Address",
    noSort: true,
    testId: "address",
  },
  countyStatus: {
    displayText: "County Status",
    noSort: true,
    testId: "county-status",
  },
  fillableGapIndicator: {
    displayText: "Fillable Gap Indicator",
    noSort: true,
    testId: "fillable-gap-indicator",
  },
  geoInfo: {
    displayText: "Geo Info",
    noSort: true,
    sizeContentToFit: true,
    testId: "geo-info"
  },
  projectLink: {
    displayText: "",
    noSort: true,
    testId: "project-link",
  },
  serviceArea: {
    displayText: "Service Area",
    noSort: true,
    testId: "service-area",
  },
  specialty: {
    displayText: "Specialty Group",
    noSort: true,
    testId: "specialty",
  },
}

export const ProviderProfileFlyoutTable: FC<ProviderProfileFlyoutTableProps> = (props: ProviderProfileFlyoutTableProps) => {
  return (
    <Waffles
      columns={columnConfig}
      data={props.data}
      fullWidth={true}
      testId="provider-profile-flyout"
    />
  );
}